<template>
  <ErrorPageTemplate
    :errorCode="errorCode"
    :errorDescription="errorDescription"
  />
</template>

<script lang="ts">
export default {
  name: "ServerError",

  metaInfo() {
    return {
      titleTemplate: `%s - ${this.errorCode}`
    }
  },

  data() {
    return {
      errorCode: 500,
      errorDescription: this.$t("error_pages.server_error"),
      prevRoute: null
    }
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.fullPath
    })
  },

  mounted() {
    const from = this.$route.query.from

    this.$nextTick(() => {
      if (from && this.prevRoute === null) {
        this.$router.push(from)
      }
    })
  },

  components: {
    ErrorPageTemplate: () => import("@/components/ErrorPages/_components/ErrorPageTemplate")
  }
}
</script>
